"use client";

import { useInstrumentation } from "@/providers/Observability.provider";
import Script from "next/script";

type Props = {
  src: string;
};

export function CMSExternalScript({ src }: Readonly<Props>) {
  const instrumentation = useInstrumentation();

  return (
    <Script
      src={src}
      strategy="afterInteractive"
      onError={() => {
        instrumentation?.captureError(
          new Error("CMS external script failed to load: " + src),
          { feature: "cms-external-script", src },
        );
      }}
    />
  );
}
